import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=8c4aab4e"
import script from "./Titles.vue?vue&type=script&lang=ts"
export * from "./Titles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports